export enum DescriptionType {
    FREE_TEXT = 1,
    TEXT_TEMPLATE = 2,
    SYNOPTIC_TEMPLATE = 3
}
